// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c1e72dff","488":"9eb5bcf2","553":"1fb55b74","977":"fdf105cf"}[chunkId] + ".chunk.js";
};